import {Spine} from 'pixi-spine';
import AssetsManager from '../../core/assets/AssetsManager';


export default class ButtonSpinAnimation extends Spine {
    public static SPIN: string = 'click_spin';
    public static STOP: string = 'click_stop';
    public static SPIN_AUTOPLAY: string = 'autospin_spin_to_stop';
    public static STOP_AUTOPLAY: string = 'autospin_stop_to_spin';
    public static WAIT: string = 'wait';
    public static WAIT_DELAY: string = 'wait_delay';

    constructor() {
        super(AssetsManager.spine.get('button-spin'));

        this.state.data.setMix(ButtonSpinAnimation.SPIN, ButtonSpinAnimation.STOP, 0.15);
        this.state.data.setMix(ButtonSpinAnimation.STOP, ButtonSpinAnimation.SPIN, 0.15);
        this.state.data.setMix(ButtonSpinAnimation.WAIT_DELAY, ButtonSpinAnimation.SPIN, 0.15);
        this.state.data.setMix(ButtonSpinAnimation.WAIT, ButtonSpinAnimation.SPIN, 0.15);
        this.state.data.setMix(ButtonSpinAnimation.STOP, ButtonSpinAnimation.WAIT_DELAY, 0.15);

        this.setAnimation(ButtonSpinAnimation.WAIT_DELAY)
    }


    public setAnimation(name: string): void {
        this.state.setAnimation(0, name,
            name === ButtonSpinAnimation.WAIT ||
            name === ButtonSpinAnimation.WAIT_DELAY);
    }

    public addAnimation(name: string, delay: number): void {
        const shouldLoop = name === ButtonSpinAnimation.WAIT || name === ButtonSpinAnimation.WAIT_DELAY;
        this.state.addAnimation(0, name, shouldLoop, delay);
    }

    public getAnimationDuration(name: string): number {
        return this.spineData.animations.find((animation) => animation.name === name).duration;
    }
}